import React from 'react';
interface MediaPlaceholderProps {
  type: 'image' | 'video' | 'gallery';
  title: string;
  description?: string;
  imageUrl?: string;
}
export function MediaPlaceholder({
  title,
  description,
  imageUrl
}: MediaPlaceholderProps) {
  // Only render when there is an actual image to show
  if (!imageUrl) return null;
  return <figure className="my-6 overflow-hidden rounded-xl border bg-card shadow-sm" data-id="element-245" data-mp="164ioxfdcb51i">
      {(title || description) && <figcaption className="border-t bg-muted/30 px-5 py-3" data-id="element-246" data-mp="idvd4j0azv9o">
          <div className="text-sm font-semibold text-foreground" data-id="element-247" data-mp="dfliqamekyp4">{title}</div>
          {description && <div className="mt-0.5 text-xs text-muted-foreground" data-id="element-248" data-mp="sckoru1lwjhh">
              {description}
            </div>}
        </figcaption>}
    </figure>;
}